import React, { useEffect, useState } from 'react'
import useMakeRequest from '../utils/ApiHelper'
import { ApiConstants } from '../constants/ApiConstants'
import { Config } from '../config/Config'
import FrontLoader from '../component/layout/FrontLoader'
import { LanguageConstants } from '../constants/LanguageConstants'
import { useSelector } from 'react-redux'


function DeleteAccount(props:any) {
    const deleteAccount = useMakeRequest()
    const [show , setShow] = useState(false)
    const [password , setPassword] = useState('')
    const [error , setError] = useState('')
    const handleDelete =()=>{
     if(!password){
        setError(LanguageConstants?.ENTER_PASSWORD)
     }else{
        const payload ={
            password:password
        }
        deleteAccount.makeRequest({ payload, url: ApiConstants?.DeleteAccount, toastStatus: true })
     }
    }
    useEffect(()=>{
    if(deleteAccount.status){
    localStorage.clear()
    window.location.href = `${Config?.BASE_URL}/login`;
    }
    },[deleteAccount.status])
   
    const handleClose =()=>{
         setError('')
         setPassword('')
         setShow(false)
         props.handleClso()
    }

    return (
        <>
        {deleteAccount.loading ? <FrontLoader/> : null}
        <div className="modal fade auth-modal text-center show" id="forgotPassModal" aria-labelledby="forgotPassModalLabel" aria-hidden="false" style={{ display: 'block' }} >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="forgotPassModalLabel">{LanguageConstants?.DELETE_ACCOUNT}</h5>
                        <button type="button" onClick={()=>handleClose()} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                    </div>
                    <div className="modal-body">
                        <div className='mb-2'>
                            <div className="com-floating mb-1">
                            <i className="f-icon icon-lock"></i>
                            <label className="f-label">{LanguageConstants?.PASSWORD} <span className="must-star">*</span></label>
                            <input className="f-input ps-5" type={show ? "text" : 'password'}  placeholder={LanguageConstants?.PASSWORD} onChange={(e)=>setPassword(e.target.value)}   />
                            <i className={show ?  "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={()=>setShow(!show)}></i>
                            </div>
                        </div>
                            <p className='text-error-new text-start'>{error}</p>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="round-btn m-0" onClick={()=>handleDelete()}>{LanguageConstants?.SUBMIT}</button>
                    </div>
                </div>
            </div>
            </div>
        </>
    )
}

export default DeleteAccount
